export const ApiConstants = {
    backend: 'backend',
    query: 'query',
    servicebench: {
        availability: 'servicebench/serviceprovideravailability',
        schedule: 'servicebench/servicejobschedule',
        statusEquiry:'servicebench/servicejobstatus',
        cancellation:'servicebench/servicejobcancellation',
        reschedule: 'servicebench/servicejobRescheduling',
    },
    servicepower: {
        availability: 'servicepower/appointmentsearch',
        schedule: 'servicepower/callassignmentreq',
        statusEquiry: 'servicepower/callstatusenquiry',
        cancellation: 'servicepower/callcancellation',
    },
    electrolux: {
        availability: 'electrolux/appointmentsearch',
        schedule: 'electrolux/bookappointment',
        cancellation: 'electrolux/cancelappointment',
        statusEquiry: 'electrolux/appointmentstatus',
    },
    triggerScheduledEmailsUrl: 'triggerscheduleemails',
    azureMapsUrl: 'azuremaps',
    userUrl: 'msgraph',
    emailUrl: 'email',
    uploadUrl: 'files'
};

export default ApiConstants;